<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-04-29 14:52:15
 * @LastEditors: JDY
-->
<template>
  <page-header-wrapper>
    <a-card style="margin-top: 24px;" :bordered="false" title="登录日志">
      <div slot="extra">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table } from '@/mixins' // 引入
import { TableToolBarList } from '@/components'

const columns = [{
    title: 'ID',
    dataIndex: 'id'
  },
  {
    title: '登录IP',
    dataIndex: 'login_ip',
    align: 'center'
  },
  {
    title: '管理员ID',
    dataIndex: 'user.name',
    align: 'center'
  },
  {
    title: '上次登录时间',
    dataIndex: 'updated_at'
  }]

const apiList = {
    getList: '/admins/loginlogs'
}

export default {
  name: 'MemberList',
  mixins: [list, table], // 使用mixins
  components: {
    TableToolBarList
  },
  data () {
    return {
        apiList,
        columns,
        settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
    }
  },
  mounted () {
    this.getLists() // 获取列表
  },
  methods: {}
}
</script>
